import { Alert, Autocomplete, Box, Button, Card, Chip, Dropdown, IconButton, Input, Link, Menu, MenuButton, MenuItem, Tab, Table, Typography } from '@mui/joy'
import React, { useState } from 'react'
import { post, Token, url } from '../../../../../Script/Session';
import { useNavigate } from 'react-router-dom';
import TarifStandViewer from '../TarifStandViewer/TarifStandViewer';
import MoreVert from '@mui/icons-material/MoreVert';
import PlaylistAddCheckCircleRoundedIcon from '@mui/icons-material/PlaylistAddCheckCircleRounded';
function TarifStände({ data, update }) {
    const [view, setview] = useState(false);
    const [viewdata, setviewdata] = useState(null);
    const [createcard, setcreatecard] = useState(false);
    let options = [{ bzh: "Ja, Pflichtdateien werden übernommen", val: true }, { bzh: "Nein, Pflichtdateien werden nicht übernommen", val: false }]
    const navigate = useNavigate();
    const [v, setv] = useState();
    const [alert, setalert] = useState(false);
    function nav() {

        const key = `create-tarif-data-${data.id}`;
        localStorage.setItem(key, JSON.stringify({
            id: data.id,
            val: v.val,
            dateien: data.dateien
        }));




        const a = window.open(
            `${window.location.origin}/create-tarif-after-first/${data.id}/${v.val}`,
            "_blank"
        );
        const timer = setInterval(() => {
            if (a?.closed) {
                clearInterval(timer);
                console.log("Download tab closed!");
                window.location.reload();
            }
        }, 500);
        setcreatecard(false);
        setv(null);
    }




    function see(id) {
        let body = {};
        body.token = Token.get();
        body.action = "get";
        body.targetid = id;
        let response = post(body, "/tarife/tarifstand");
        if (response === "LOGOUT") {
            navigate("/");
        }
        console.log("DEBUG VIEWDATA " + response);
        setviewdata(JSON.parse(response));
        setview(true);
    }
    function deltarifstand(id) {
        let body = {};
        body.token = Token.get();
        body.action = "delete";
        body.targetid = id;
        body.tarifid = data.id;
        let response = post(body, "/tarife/tarifstand");
        if (response === "LOGOUT") {
            navigate("/");
        }
        if (response === "OK") {
            setalert(true);
            update();
        }



    }
    function editempfehlung(id, edit) {
        let body = {};
        body.token = Token.get();
        body.action = "get";
        body.targetid = id;
        let response = post(body, "/tarife/tarifstand");
        if (response === "LOGOUT") {
            navigate("/");
        }
        localStorage.setItem("empfehlung_edit_data", JSON.stringify({
            response,
            edit
        }));
        const a = window.open(
            `${window.location.origin}/edit_tarifstand_empfehlung`
            , "_blank");

        const timer = setInterval(() => {
            if (a?.closed) {
                clearInterval(timer);
                console.log("Download tab closed!");
                window.location.reload();
            }
        }, 500);
    }
    function lockstand(id, g) {
        let body = {};
        body.token = Token.get();
        body.action = "sperren";
        body.targetid = id;
        body.vl = g;

        let response = post(body, "/tarife/tarifstand");
        if (response === "LOGOUT") {
            navigate("/");
        }
        update();

    }
    const [edittimemode, setedittimemode] = useState(false);
    const [edittimetarget, setedittimetarget] = useState();
    const [inputtime, setinputtime] = useState();
    function settime(itemid) {
        setedittimemode(true);
        setedittimetarget(itemid);
    }
    function savetimestamp() {
        let body = {};
        body.token = Token.get();
        body.action = "setstempel";
        body.targetid = edittimetarget;
        body.timestamp = inputtime;
        let response = post(body, "/tarife/tarifstand");
        if (response === "LOGOUT") {
            navigate("/");
        }
        update();
        setedittimemode(false);
        setedittimetarget();
        setinputtime();
    }
    return (
        <>
            {
                alert && (
                    <Alert
                        sx={{ mb: 5 }}
                        variant="soft"
                        color="success"
                        startDecorator={<PlaylistAddCheckCircleRoundedIcon />}
                        endDecorator={
                            <Button size="sm" variant="solid" color="success" onClick={() => setalert(false)}>
                                Schliesen
                            </Button>
                        }
                    >
                        Ihre änderungen wurden Erfolgreich gespeichert.
                    </Alert>
                )
            }
            {
                createcard && (
                    <Box sx={{ p: 2 }}>
                        <Card variant='soft'>
                            <Typography level="title-md">Tarifstand erstellen!</Typography>
                            <Typography>Sollen die pflichtdateien übernommen werden?</Typography>
                            <Typography sx={{ color: "red" }}>Achtung! Alle übernommen Dateien sowie die neu hochgeladenen werden als GEPRÜFT betrachtet!</Typography>
                            <Autocomplete onChange={(e, newval) => setv(newval)} options={options} getOptionLabel={(item) => item.bzh} />
                            <Button onClick={() => nav()} sx={{ width: "15%" }}>Erstellen beginnen</Button>
                        </Card>
                    </Box>
                )
            }
            {
                edittimemode && (
                    <Card>
                        <Input
                            type="date"
                            value={inputtime ? new Date(inputtime).toISOString().split('T')[0] : ''}
                            onChange={(e) => {
                                const val = e.target.value;
                                setinputtime(val ? new Date(val).getTime() : null);
                            }}
                        />
                        <Button onClick={() => savetimestamp()}>
                            Speichern
                        </Button>
                    </Card>
                )
            }
            {
                !view && (
                    <Box sx={{ p: 2 }}>
                        <Typography>Tarifname:{data.gesellschaft} {data.name}</Typography>
                        <Table>
                            <thead>
                                <tr>
                                    <th>
                                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                            <Typography>Stände</Typography>

                                        </Box>
                                    </th>
                                    {data.editperms && (
                                        <th>
                                            <Typography>Bearbeiten</Typography>
                                        </th>
                                    )}
                                    {data.editperms && (
                                        <th>
                                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                <Typography>Status</Typography>
                                                {
                                                    data.editperms ? (
                                                        <Button onClick={() => setcreatecard(true)}>Tarifstand erstellen</Button>
                                                    ) : (
                                                        <Typography></Typography>
                                                    )
                                                }
                                            </Box>
                                        </th>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    data && data.stände && data.stände.sort((a, b) => b.timestamp - a.timestamp).filter((g) => {
                                        if (data.editperms) {
                                            return true;
                                        }
                                        if (g.locked) {
                                            return false;
                                        } else {
                                            return true;
                                        }

                                    }).map((item) => {
                                        return (
                                            <>
                                                <tr key={item.id}>
                                                    <td onClick={() => see(item.id)}><Link>{item.label.split(" ")[0]}</Link></td>
                                                    {data.editperms && (
                                                        <td>
                                                            <Dropdown>
                                                                <MenuButton
                                                                    slots={{ root: IconButton }}
                                                                    slotProps={{ root: { variant: 'outlined', color: 'neutral' } }}
                                                                >
                                                                    <MoreVert />
                                                                </MenuButton>
                                                                <Menu>
                                                                    <MenuItem onClick={() => {
                                                                        const key = `tarif-stand-edit-${item.id}`;

                                                                        // Save the required data in localStorage
                                                                        localStorage.setItem(key, JSON.stringify({
                                                                            fragen: data.fragen,
                                                                            tarifId: data.id
                                                                        }));

                                                                        const a = window.open(
                                                                            `${window.location.origin}/tarif_stand_edit_fragen/${item.id}`,
                                                                            "_blank"
                                                                        );
                                                                        const timer = setInterval(() => {
                                                                            if (a?.closed) {
                                                                                clearInterval(timer);
                                                                                console.log("Download tab closed!");
                                                                                window.location.reload();
                                                                            }
                                                                        }, 500);


                                                                    }}>Leistungsbeschreibung Bearbeiten</MenuItem>
                                                                    <MenuItem onClick={() => settime(item.id)}>Zeitstempel bearbeiten</MenuItem>
                                                                    <MenuItem onClick={() => {
                                                                        const a = window.open(
                                                                            `${window.location.origin}/edit_tarifstand_dateien/${item.id}/${data.subkath}/${data.type}`,
                                                                            "_blank",
                                                                        )
                                                                        const timer = setInterval(() => {
                                                                            if (a?.closed) {
                                                                                clearInterval(timer);
                                                                                console.log("Download tab closed!");
                                                                                window.location.reload();
                                                                            }
                                                                        }, 500);
                                                                    }} >Dateien Bearbeiten</MenuItem>
                                                                    <MenuItem onClick={() => lockstand(item.id, !item.locked)}>
                                                                        Tarifstand {item.locked ? "Freigeben" : "Sperren"}
                                                                    </MenuItem>
                                                                    <MenuItem
                                                                        onClick={() => {
                                                                            editempfehlung(item.id, true);
                                                                        }}

                                                                    >Empfehlung Bearbeiten</MenuItem>
                                                                    <MenuItem sx={{ color: "red" }} onClick={
                                                                        () => deltarifstand(item.id)
                                                                    }>Tarifstand Löschen</MenuItem>
                                                                </Menu>
                                                            </Dropdown>



                                                        </td>
                                                    )}
                                                    {
                                                        data.editperms && (
                                                            <td>
                                                                <Chip color={item.locked ? "danger" : "success"}>{item.locked ? "Gesperrt" : "Öffentlich"}</Chip>
                                                            </td>
                                                        )
                                                    }
                                                </tr>
                                            </>

                                        );
                                    })
                                }





                            </tbody>
                        </Table>
                    </Box>
                )
            }
            {
                view && (

                    <TarifStandViewer data={viewdata} fragen={data.fragen} back={true} setback={setview} perms={data.editperms} subkath={data.subkath} />

                )
            }

        </>
    )
}

export default TarifStände
